module.exports = __webpack_public_path__ + "img/Geothon.a6d06624.png";